import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="absolute inset-0 bg-stone-900/60 backdrop-blur-sm"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="relative w-full max-w-3xl max-h-[85vh] bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col"
        >
          <div className="flex items-center justify-between p-6 border-b border-stone-100">
            <h3 className="text-xl font-bold text-stone-900">{title}</h3>
            <button
              onClick={onClose}
              className="p-2 hover:bg-stone-100 rounded-full transition-colors"
            >
              <SafeIcon icon={FiX} className="text-xl text-stone-500" />
            </button>
          </div>
          <div className="p-8 overflow-y-auto text-stone-600 leading-relaxed prose prose-stone max-w-none">
            {children}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export const ImpressumContent = () => (
  <div className="space-y-6 text-sm">
    <section>
      <h4 className="text-stone-900 font-bold mb-2">Angaben gemäß § 5 TMG</h4>
      <p>
        Martin Habibi<br />
        CoreUnit Systems<br />
        Westmarkstr. 47<br />
        26676 Barßel<br />
        Deutschland
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">Kontakt</h4>
      <p>E-Mail: info@coreunit-systems.de</p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">Umsatzsteuer-ID</h4>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
        [USt-IdNr. eintragen, sofern vorhanden]
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h4>
      <p>
        Martin Habibi<br />
        Westmarkstr. 47<br />
        26676 Barßel
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">Streitschlichtung</h4>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-600 hover:underline"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        .<br /><br />
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </section>
  </div>
);

export const PrivacyContent = () => (
  <div className="space-y-6 text-sm">

    <section>
      <h4 className="text-stone-900 font-bold mb-2">1. Verantwortlicher</h4>
      <p>
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
        Martin Habibi<br />
        CoreUnit Systems<br />
        Westmarkstr. 47<br />
        26676 Barßel<br />
        Deutschland<br />
        E-Mail: info@coreunit-systems.de
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">2. Allgemeines zur Datenverarbeitung</h4>
      <p>
        Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
        Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
        erforderlich ist. Die Verarbeitung personenbezogener Daten erfolgt regelmäßig nur nach
        Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige
        Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die
        Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">3. Rechtsgrundlagen der Verarbeitung</h4>
      <p>
        Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
        betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.<br /><br />
        Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages
        erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage.<br /><br />
        Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
        Verpflichtung erforderlich ist, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.<br /><br />
        Ist die Verarbeitung zur Wahrung eines berechtigten Interesses erforderlich und überwiegen
        die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse
        nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">4. Server-Log-Dateien</h4>
      <p>
        Der Provider dieser Website erhebt und speichert automatisch Informationen in sogenannten
        Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
      </p>
      <ul className="list-disc pl-5 mt-2 space-y-1">
        <li>Browsertyp und Browserversion</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer-URL</li>
        <li>Hostname des zugreifenden Rechners</li>
        <li>Datum und Uhrzeit der Serveranfrage</li>
        <li>IP-Adresse (anonymisiert)</li>
      </ul>
      <p className="mt-3">
        Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten
        mit anderen Datenquellen wird nicht vorgenommen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
        DSGVO. Die Daten werden nach spätestens 7 Tagen automatisch gelöscht.
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">5. Hosting</h4>
      <p>
        Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die
        personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des
        Hosters gespeichert. Hierbei handelt es sich um IP-Adressen, Kontaktanfragen, Meta- und
        Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige
        Daten, die über eine Website generiert werden.<br /><br />
        Der Einsatz des Hosters erfolgt im Interesse einer sicheren, schnellen und effizienten
        Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter
        (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">6. Cookies</h4>
      <p>
        Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb
        der Seite unbedingt erforderlich sind. Diese Cookies speichern keine personenbezogenen
        Daten und erfordern keine Einwilligung gemäß Art. 6 Abs. 1 lit. f DSGVO. Cookies, die
        einer Einwilligung bedürfen, werden auf dieser Website nicht eingesetzt.
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">7. Kontaktaufnahme per E-Mail</h4>
      <p>
        Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen übermittelten Daten (Ihre
        E-Mail-Adresse, ggf. Ihr Name und Ihre Telefonnummer) gespeichert, um Ihre Anfrage zu
        bearbeiten. Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die
        Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls
        gesetzliche Aufbewahrungspflichten bestehen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
        DSGVO.
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">8. Ihre Rechte als betroffene Person</h4>
      <p className="mb-2">
        Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden
        personenbezogenen Daten:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong className="text-stone-700">Auskunftsrecht</strong> (Art. 15 DSGVO)</li>
        <li><strong className="text-stone-700">Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
        <li><strong className="text-stone-700">Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
        <li><strong className="text-stone-700">Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
        <li><strong className="text-stone-700">Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
        <li><strong className="text-stone-700">Widerspruchsrecht</strong> (Art. 21 DSGVO)</li>
        <li><strong className="text-stone-700">Recht auf Widerruf einer Einwilligung</strong> (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <p className="mt-3">
        Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@coreunit-systems.de
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">9. Beschwerderecht bei der Aufsichtsbehörde</h4>
      <p>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung
        Ihrer personenbezogenen Daten durch uns zu beschweren. Die zuständige Aufsichtsbehörde
        für Niedersachsen ist:<br /><br />
        <strong className="text-stone-700">Die Landesbeauftragte für den Datenschutz Niedersachsen</strong><br />
        Prinzenstraße 5<br />
        30159 Hannover<br />
        Telefon: +49 511 120-4500<br />
        E-Mail: poststelle@lfd.niedersachsen.de<br />
        Web:{' '}
        <a
          href="https://www.lfd.niedersachsen.de"
          target="_blank"
          rel="noopener noreferrer"
          className="text-emerald-600 hover:underline"
        >
          www.lfd.niedersachsen.de
        </a>
      </p>
    </section>

    <section>
      <h4 className="text-stone-900 font-bold mb-2">10. Aktualität und Änderung dieser Datenschutzerklärung</h4>
      <p>
        Diese Datenschutzerklärung ist aktuell gültig und hat den Stand:{' '}
        {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}.<br /><br />
        Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw.
        behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
      </p>
    </section>

  </div>
);

export default Modal;